import { render, staticRenderFns } from "./ManageParcelle.vue?vue&type=template&id=36d69f42&scoped=true"
import script from "./ManageParcelle.vue?vue&type=script&lang=js"
export * from "./ManageParcelle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d69f42",
  null
  
)

export default component.exports